// import Vue from 'vue'
// import App from './App.vue'
// import { Swipe, SwipeItem } from 'vant';

// Vue.use(Swipe);
// Vue.use(SwipeItem);
// Vue.config.productionTip = false

// new Vue({
//   render: h => h(App),
// }).$mount('#app')


import Vue from 'vue'
import App from './App.vue'
import router from 'vue-router' // 确保已安装并配置了vue-router
import { Swipe, SwipeItem } from 'vant';
import TlbsMap from 'tlbs-map-vue'; // 导入地图组件

// 注册Vant组件
Vue.use(Swipe);
Vue.use(SwipeItem);

// 注册地图组件 (Vue2方式)
Vue.use(TlbsMap);

Vue.config.productionTip = false

// Vue2标准初始化方式
new Vue({
  router, // 注入路由
  render: h => h(App),
}).$mount('#app')